module.exports = __webpack_public_path__ + "img/2.015e639d.png";